(function (global, factory) {
    /* eslint-disable */
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
    (global = global || self, global.ksBridgeFactory = factory());
    /* eslint-enable */
}(this, function () {
    'use strict';
    var bridge = require('./ks-bridge.2.0.3.js');
    if (bridge && bridge.__esModule) {
        bridge = bridge.default;
    }
    bridge.ksBridge = bridge.ksBridge || bridge;
    return bridge;
}));
